import {
  EXTERNAL_CHANNEL,
  MARKET_SDK_CHANNEL,
  APPLY_SOURCE,
  waSourceMap,
} from '@/constants/common'
import { isMgm, isOfficalWeb, isMarket } from './scene'
import { querySet } from '@/utils/url'

// 判断当前是移动端、pc端
export const deviceDetector = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile =
    /iphone|ipod|android|windows phone|blackberry|opera mini|mobile/i.test(
      userAgent
    )
  return isMobile
}

export const getBrowserType = (): string => {
  const nav = navigator as Navigator & {
    userAgentData?: {
      brands?: Array<{ brand: string; version: string }>
    }
  }
  const brands = nav.userAgentData?.brands || []
  const brandString = brands.map(item => item.brand.toLowerCase()).join(' ')

  if (brandString.includes('edge') || brandString.includes('edg')) return 'edge'
  if (brandString.includes('opera') || brandString.includes('opr')) return 'opera'
  if (brandString.includes('firefox')) return 'firefox'
  if (brandString.includes('chrome') || brandString.includes('chromium')) return 'chrome'
  if (brandString.includes('safari')) return 'safari'

  const ua = navigator.userAgent.toLowerCase()
  if (ua.includes('edg/')) return 'edge'
  if (ua.includes('opr/') || ua.includes('opera')) return 'opera'
  if (ua.includes('firefox/')) return 'firefox'
  if (ua.includes('safari') && !ua.includes('chrome') && !ua.includes('crios') && !ua.includes('android')) return 'safari'
  if (ua.includes('chrome/') || ua.includes('crios/')) return 'chrome'
  if (ua.includes('msie') || ua.includes('trident/')) return 'ie'
  return 'other'
}

export const getBrowserVersion = (): string => {
  const ua = navigator.userAgent

  const patterns: Array<[RegExp, number]> = [
    [/edg\/([\d.]+)/i, 1],
    [/opr\/([\d.]+)/i, 1],
    [/firefox\/([\d.]+)/i, 1],
    [/version\/([\d.]+).*safari/i, 1],
    [/chrome\/([\d.]+)/i, 1],
    [/crios\/([\d.]+)/i, 1],
    [/msie\s([\d.]+)/i, 1],
    [/trident\/.*rv:([\d.]+)/i, 1],
  ]

  for (const [pattern, groupIndex] of patterns) {
    const match = ua.match(pattern)
    if (match?.[groupIndex]) {
      return match[groupIndex]
    }
  }

  return 'unknown'
}

export const getBrowserLanguage = (): string => {
  return navigator.language || 'unknown'
}

export const getNetworkType = (): string => {
  const nav = navigator as Navigator & {
    connection?: {
      effectiveType?: string
      type?: string
    }
  }
  return nav.connection?.effectiveType || nav.connection?.type || 'unknown'
}

// 文案高亮
export const addHighlightStyle = (
  transResult: string,
  className: string
) => {
  const regexp = /{([^}]+)}/g
  return transResult.replace(
    regexp,
    `<span class="${className}">$1</span>`
  )
}

// 是否超过24小时
export const isOver24Hours = (timestamp: number) => {
  const currentTimestamp = Date.now() // 当前时间戳（毫秒级）
  const difference = currentTimestamp - timestamp // 时间差，单位：毫秒

  // 判断时间差是否大于等于 24 小时（24 小时 * 60 分钟 * 60 秒 * 1000 毫秒）
  return difference >= 24 * 60 * 60 * 1000
}

// localStorage方法
export const Storage = {
  // 设置数据
  setItem(key: string, value: any) {
    // 如果 value 是对象或数组，需要将其转换为 JSON 字符串
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    localStorage.setItem(key, value)
  },

  // 获取数据
  getItem(key: string) {
    const value = localStorage.getItem(key)
    // 如果获取到的是 JSON 格式的数据，自动解析
    if (value) {
      try {
        return JSON.parse(value)
      } catch (e) {
        return value // 如果不是 JSON 格式，直接返回原值
      }
    }
    return null // 如果没有数据，返回 null
  },
}

export const getExternalChannel = () => {
  const marketScene = isMarket()
  const grantToken = querySet.grant_token || ''
  // whatsapp渠道 原有渠道区分 + 链接是否包含ticket参数
  if (grantToken) {
    if (marketScene) {
      const channel = window?.adv?.getChannelEnv()
      switch (channel) {
        case MARKET_SDK_CHANNEL.meta: {
          return EXTERNAL_CHANNEL.meta_wa
        }
        case MARKET_SDK_CHANNEL.google: {
          return EXTERNAL_CHANNEL.google_wa
        }
        default: {
          return EXTERNAL_CHANNEL.external_default_wa
        }
      }
    } else if (isMgm()) {
      return EXTERNAL_CHANNEL.mgm_wa
    } else {
      return EXTERNAL_CHANNEL.external_default_wa
    }
  } else {
    if (marketScene) {
      const channel = window?.adv?.getChannelEnv()
      switch (channel) {
        case MARKET_SDK_CHANNEL.ec: {
          return EXTERNAL_CHANNEL.ec
        }
        case MARKET_SDK_CHANNEL.meta: {
          return EXTERNAL_CHANNEL.meta
        }
        case MARKET_SDK_CHANNEL.google: {
          return EXTERNAL_CHANNEL.google
        }
        case MARKET_SDK_CHANNEL.tiktok: {
          return EXTERNAL_CHANNEL.tiktok
        }
        default: {
          return EXTERNAL_CHANNEL.other
        }
      }
    } else if (isMgm()) {
      return EXTERNAL_CHANNEL.mgm
    } else if (isOfficalWeb()) {
      return EXTERNAL_CHANNEL.web
    } else {
      return EXTERNAL_CHANNEL.other
    }
  }
}

// 获取埋点申请渠道参数
export const getOmegaApplySource = () => {
  if (isMgm()) {
    return APPLY_SOURCE['MGM']
  }
  if (isOfficalWeb()) {
    return APPLY_SOURCE['WEB']
  }
  if (isMarket()) {
    return APPLY_SOURCE['OUT']
  }
  return APPLY_SOURCE.DEFAULT
}

/**
 * 有意义时间打点
 */
export function markPerformanceFMP() {
  try {
    performance?.mark('fmp')
  } catch (err) {
    console.error('performance mark not find')
  }
}
